// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"ca4e2787","202":"8a3a3f62","248":"7b94b323","693":"63f7ee56","784":"457abafc"}[chunkId] + ".chunk.css";
};